import { render, staticRenderFns } from "./MetaDataFromURL.vue?vue&type=template&id=0724941a"
import script from "./MetaDataFromURL.vue?vue&type=script&lang=js"
export * from "./MetaDataFromURL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports